module.exports = __webpack_public_path__ + "img/spray-can-sparkles.b2d30f07.svg";